// src/data/screensData.js - Contains all screen product data
import { getPriceComparisonUrl } from '../utils/productUrlMapping';

export const screensData = [
  {
    id: "echomap-73sv-uhd2",
    name: "Garmin ECHOMAP UHD2 73sv",
    screenSize: "7",
    viewOnPhone: "No",
    hdmiOut: "No",
    hdmiIn: "No",
    networkPorts: "1",
    bncVideoIn: "No",
    controlMethod: "Touchscreen",
    msrp: 899.99,
    csvLookupId: "ECHOMAP UHD2 73sv",
    resolution: "800 x 480",
    powerDraw12V: "1.52",
    image: "/images/screens/garmin-echomap-uhd2-73sv.jpg",
    description: "7-inch touchscreen with keyed assist",
    controlDescription: "Touchscreen with keyed assist",
    notes: "Great mid-range option with touchscreen.",
    productLink: "https://at.fish/EchomapUHD2-73sv",
    priceComparisonUrl: getPriceComparisonUrl("ECHOMAP UHD2 73sv")
  },
  {
    id: "echomap-93sv-uhd2",
    name: "Garmin ECHOMAP UHD2 93sv",
    screenSize: "9",
    viewOnPhone: "No",
    hdmiOut: "No",
    hdmiIn: "No",
    networkPorts: "1",
    bncVideoIn: "No",
    controlMethod: "Touchscreen",
    msrp: 1199.99,
    csvLookupId: "ECHOMAP UHD2 93sv",
    resolution: "1024 x 600",
    powerDraw12V: "1.72",
    image: "/images/screens/garmin-echomap-uhd2-93sv.jpg",
    description: "9-inch touchscreen with keyed assist",
    controlDescription: "Touchscreen with keyed assist",
    notes: "Great mid-range option with touchscreen.",
    productLink: "https://at.fish/EchomapUHD2-93sv",
    priceComparisonUrl: getPriceComparisonUrl("ECHOMAP UHD2 93sv")
  },
  {
    id: "echomap-ultra-2-106sv",
    name: "Garmin ECHOMAP Ultra 2 106sv",
    screenSize: "10",
    viewOnPhone: "Yes",
    hdmiOut: "No",
    hdmiIn: "No",
    networkPorts: "2",
    bncVideoIn: "No",
    controlMethod: "Touchscreen",
    msrp: 2099.99,
    csvLookupId: "Echomap Ultra 2 106sv",
    resolution: "1280 x 800",
    powerDraw12V: "2.3",
    image: "/images/screens/garmin-echomap-ultra2-106sv.jpg",
    description: "10-inch touchscreen with keyed assist",
    controlDescription: "Touchscreen with keyed assist",
    notes: "Premium features with excellent screen clarity.",
    productLink: "https://at.fish/echomap-ultra-2-106sv",
    priceComparisonUrl: getPriceComparisonUrl("Echomap Ultra 2 106sv")
  },
  {
    id: "echomap-ultra-2-126sv",
    name: "Garmin ECHOMAP Ultra 2 126sv",
    screenSize: "12",
    viewOnPhone: "Yes",
    hdmiOut: "No",
    hdmiIn: "No",
    networkPorts: "2",
    bncVideoIn: "No",
    controlMethod: "Touchscreen",
    msrp: 2899.99,
    csvLookupId: "Echomap Ultra 2 126sv",
    resolution: "1280 x 800",
    powerDraw12V: "2.5",
    image: "/images/screens/garmin-echomap-ultra2-126sv.jpg",
    description: "12-inch touchscreen with keyed assist",
    controlDescription: "Touchscreen with keyed assist",
    notes: "Large screen with premium features.",
    productLink: "https://at.fish/echomap-ultra-2-126sv",
    priceComparisonUrl: getPriceComparisonUrl("Echomap Ultra 2 126sv")
  },
  {
    id: "gpsmap-8610xsv",
    name: "Garmin GPSMAP 8610xsv",
    screenSize: "10",
    viewOnPhone: "Yes",
    hdmiOut: "Yes",
    hdmiIn: "Yes",
    networkPorts: "2",
    bncVideoIn: "Yes",
    controlMethod: "Touchscreen",
    msrp: 2999.99,
    csvLookupId: "GPSMAP 8610xsv",
    resolution: "1920 x 1200",
    powerDraw12V: "1.5",
    image: "/images/screens/garmin-gpsmap-8610xsv.jpg",
    fallbackImage: "https://dummyimage.com/150x100/cccccc/000000&text=GPSMAP+8610xsv",
    productLink: "https://at.fish/gpsmap-8610xsv",
    priceComparisonUrl: getPriceComparisonUrl("GPSMAP 8610xsv")
  },
  {
    id: "gpsmap-8612xsv",
    name: "Garmin GPSMAP 8612xsv",
    screenSize: "12",
    viewOnPhone: "Yes",
    hdmiOut: "Yes",
    hdmiIn: "Yes",
    networkPorts: "2",
    bncVideoIn: "Yes",
    controlMethod: "Touchscreen",
    msrp: 4299.99,
    csvLookupId: "GPSMAP 8612xsv",
    resolution: "1920 x 1080",
    powerDraw12V: "1.3",
    image: "/images/screens/garmin-gpsmap-8612xsv.jpg",
    fallbackImage: "https://dummyimage.com/150x100/cccccc/000000&text=GPSMAP+8612xsv",
    productLink: "https://at.fish/gpsmap-8612xsv",
    priceComparisonUrl: getPriceComparisonUrl("GPSMAP 8612xsv")
  },
  {
    id: "gpsmap-943xsv",
    name: "Garmin GPSMAP 943xsv",
    screenSize: "9",
    viewOnPhone: "Yes",
    hdmiOut: "No",
    hdmiIn: "No",
    networkPorts: "1",
    bncVideoIn: "Yes",
    controlMethod: "Touchscreen",
    msrp: 1599.99,
    csvLookupId: "GPSMAP 943xsv",
    resolution: "1280 x 720",
    powerDraw12V: "1.37",
    image: "/images/screens/garmin-gpsmap-943xsv.jpg",
    fallbackImage: "https://dummyimage.com/150x100/cccccc/000000&text=GPSMAP+943xsv",
    productLink: "https://at.fish/gpsmap-943xsv",
    priceComparisonUrl: getPriceComparisonUrl("GPSMAP 943xsv")
  },
  {
    id: "gpsmap-1243xsv",
    name: "Garmin GPSMAP 1243xsv",
    screenSize: "12",
    viewOnPhone: "Yes",
    hdmiOut: "Yes",
    hdmiIn: "No",
    networkPorts: "1",
    bncVideoIn: "Yes",
    controlMethod: "Touchscreen",
    msrp: 3099.99,
    csvLookupId: "GPSMAP 1243xsv",
    resolution: "1280 x 800",
    powerDraw12V: "1.68",
    image: "/images/screens/garmin-gpsmap-1243xsv.jpg",
    fallbackImage: "https://dummyimage.com/150x100/cccccc/000000&text=GPSMAP+1243xsv",
    productLink: "https://at.fish/gpsmap-1243xsv",
    priceComparisonUrl: getPriceComparisonUrl("GPSMAP 1243xsv")
  },
  {
    id: "gpsmap-1042xsv",
    name: "Garmin GPSMAP 1042xsv",
    screenSize: "10",
    viewOnPhone: "Yes",
    hdmiOut: "No",
    hdmiIn: "No",
    networkPorts: "1",
    bncVideoIn: "Yes",
    controlMethod: "Keypad",
    msrp: 1699.99,
    csvLookupId: "GPSMAP 1042xsv",
    resolution: "1280 x 800",
    powerDraw12V: "1.9",
    image: "/images/screens/garmin-gpsmap-1042xsv.jpg",
    fallbackImage: "https://dummyimage.com/150x100/cccccc/000000&text=GPSMAP+1042xsv",
    productLink: "https://at.fish/gpsmap-1042xsv",
    priceComparisonUrl: getPriceComparisonUrl("GPSMAP 1042xsv")
  },
  {
    id: "gpsmap-1242xsv",
    name: "Garmin GPSMAP 1242xsv",
    screenSize: "12",
    viewOnPhone: "Yes",
    hdmiOut: "No",
    hdmiIn: "No",
    networkPorts: "1",
    bncVideoIn: "Yes",
    controlMethod: "Keypad",
    msrp: 2399.99,
    csvLookupId: "GPSMAP 1242xsv",
    resolution: "1280 x 800",
    powerDraw12V: "2.2",
    image: "/images/screens/garmin-gpsmap-1242xsv.jpg",
    fallbackImage: "https://dummyimage.com/150x100/cccccc/000000&text=GPSMAP+1242xsv",
    productLink: "https://at.fish/gpsmap-1242xsv",
    priceComparisonUrl: getPriceComparisonUrl("GPSMAP 1242xsv")
  }
]; 